/* MONORETRO V4 — opening behaviour (fixed / time of day), outfit switch, garment menus. No dependencies. */
(function () {
  'use strict';
  if (window.__np) return; window.__np = true;
  var d = document;
  var lang = d.documentElement.lang || 'en';
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  var now = new Date();
  var h = now.getHours();
  var liveStamp = "'" + String(now.getFullYear()).slice(2) + ' ' + (now.getMonth() + 1) + ' ' + now.getDate() + '  ' + pad(h) + ':' + pad(now.getMinutes());

  /* ---------- Opening ---------- */
  var open = d.querySelector('[data-np-open]');
  if (open) {
    var mode = open.getAttribute('data-mode');
    var frames = Array.prototype.slice.call(open.querySelectorAll('[data-from]'));
    var pick = frames[0] || null;
    if (mode === 'time' && frames.length > 1) {
      // The image whose start hour is the latest one not after now (wrapping past midnight).
      var best = -1; pick = null;
      frames.forEach(function (f) { var from = +f.getAttribute('data-from'); if (from <= h && from > best) { best = from; pick = f; } });
      if (!pick) frames.forEach(function (f) { var from = +f.getAttribute('data-from'); if (from > best) { best = from; pick = f; } });
      frames.forEach(function (f) { f.hidden = f !== pick; if (f === pick) { var img = f.querySelector('img'); if (img) img.loading = 'eager'; } });
      var names = {};
      try { names = JSON.parse(open.querySelector('[data-np-parts]').textContent); } catch (e) {}
      var partEl = open.querySelector('[data-np-part]');
      if (pick && partEl && names[pick.getAttribute('data-part')]) partEl.textContent = names[pick.getAttribute('data-part')];
      var wd = open.querySelector('[data-np-weekday]');
      if (wd) { try { wd.textContent = new Intl.DateTimeFormat(lang, { weekday: 'long' }).format(now) + ', ' + pad(h) + ':' + pad(now.getMinutes()) + ' · '; } catch (e) {} }
    }
    if (open.getAttribute('data-stamp-mode') === 'live' && pick) {
      var st = pick.querySelector('[data-stamp]'); if (st) st.textContent = liveStamp;
    }
  }

  /* ---------- Outfit switch (Men / Women) ---------- */
  d.querySelectorAll('[data-np-allday]').forEach(function (sec) {
    var btns = sec.querySelectorAll('[data-np-seq]');
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var which = b.getAttribute('data-np-seq');
        btns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        sec.querySelectorAll('[data-np-seq-list]').forEach(function (l) { l.hidden = l.getAttribute('data-np-seq-list') !== which; });
      });
    });
  });

  /* ---------- Garment menus (desktop): hover opens for pointer users; the toggle button opens for keyboard and touch ---------- */
  var items = Array.prototype.slice.call(d.querySelectorAll('[data-nav-item]'));
  var setOpen = function (item, on) {
    item.classList.toggle('is-open', on);
    var t = item.querySelector('[data-nav-toggle]'); if (t) t.setAttribute('aria-expanded', on ? 'true' : 'false');
  };
  var closeAll = function (except) { items.forEach(function (it) { if (it !== except) setOpen(it, false); }); };
  items.forEach(function (item) {
    var t = item.querySelector('[data-nav-toggle]');
    var hoverTimer;
    if (t) t.addEventListener('click', function () { var on = !item.classList.contains('is-open'); closeAll(item); setOpen(item, on); });
    item.addEventListener('mouseenter', function (e) { if (e.pointerType === 'touch') return; clearTimeout(hoverTimer); closeAll(item); setOpen(item, true); });
    item.addEventListener('mouseleave', function () { hoverTimer = setTimeout(function () { setOpen(item, false); }, 160); });
    item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) setOpen(item, false); });
    item.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && item.classList.contains('is-open')) { setOpen(item, false); if (t) t.focus(); }
    });
  });
  d.addEventListener('click', function (e) { if (!e.target.closest('[data-nav-item]')) closeAll(); });

  /* ---------- Scene strips: previous / next on desktop (touch devices swipe) ---------- */
  Array.prototype.forEach.call(d.querySelectorAll('[data-np-strip]'), function (strip) {
    var sec = strip.closest('section'); if (!sec) return;
    var prev = sec.querySelector('[data-np-strip-prev]'), next = sec.querySelector('[data-np-strip-next]');
    if (!prev || !next) return;
    var items = Array.prototype.slice.call(strip.children);
    // Index of the first frame at (or past) the strip's snap line; moving goes to its neighbour's snap position.
    var current = function () {
      var edge = strip.getBoundingClientRect().left + (parseFloat(getComputedStyle(strip).scrollPaddingLeft) || 0);
      for (var i = 0; i < items.length; i++) if (items[i].getBoundingClientRect().left >= edge - 4) return i;
      return items.length - 1;
    };
    var go = function (dir) {
      var i = Math.max(0, Math.min(items.length - 1, current() + dir));
      strip.scrollTo({ left: items[i].offsetLeft - items[0].offsetLeft, behavior: 'smooth' });
    };
    var sync = function () { prev.disabled = strip.scrollLeft <= 2; next.disabled = strip.scrollLeft + strip.clientWidth >= strip.scrollWidth - 2; };
    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    strip.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync); sync();
  });
})();
